import script from "./AssignEntity.vue?vue&type=script&setup=true&lang=js"
export * from "./AssignEntity.vue?vue&type=script&setup=true&lang=js"

import "./AssignEntity.vue?vue&type=style&index=0&id=5d390680&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d390680"]])

export default __exports__